import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'checklistAriaLabel' })
export class ChecklistAriaLabelPipe implements PipeTransform {
    transform(title: string, isCompleted: boolean): string {
        return `${title}. ${isCompleted ? 'Checked' : 'Unchecked'}`;
    }
}
